// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"372be037","703":"ebef1a33","787":"86a99ea4"}[chunkId] + ".chunk.js";
};